<!-- 检测数据 form 组件 -->
<template>
  <h-inspection-page :title="h_i18n('337bffab47e921014ae18dea50127fae')+data.title" @inspection-update="inspectionUpdate" :flag="false" class="ComponentDetectData_style">
    
    <h-button-group v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
        <h-button type="primary" :loading="data.exportLoading" @click="removeBtn">
          <delete />{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</h-button>
          <h-button type="primary" :loading="data.exportLoading" @click="allImport">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 3H13V12H14V3C14 2.44772 13.5523 2 13 2H4V3Z" fill="#165dff" fill-opacity="0.9"/>
<path d="M6.58325 9.41669V12.3334L7.58325 12.3334V9.41669H10.3334V8.41669H7.58325V5.66669H6.58325V8.41669H3.66675V9.41669H6.58325Z" fill="#165dff" fill-opacity="0.9"/>
<path d="M2 13C2 13.5523 2.44772 14 3 14L11 14C11.5523 14 12 13.5523 12 13L12 5C12 4.44772 11.5523 4 11 4H3C2.44772 4 2 4.44772 2 5V13ZM3 5L11 5L11 13L3 13L3 5Z" fill="#165dff" fill-opacity="0.9"/>
</svg><span style="padding-left:5px"></span>{{ h_i18n('407f3df2c996cb376f253cb597127317') }}</h-button>
          <h-button type="primary" :loading="data.addBtnLoading" @click="addBtn">
            <add-four/>{{ h_i18n('b58c7549c0246c55b9cac96383200338') }}</h-button>
      </h-button-group>
<br/>
<el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="tableLoading" @selection-change="handleSelectionChange"
  border :data="data.dataOfTable" size="small" height="100%" style="width: 100%;min-height:540px" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
  <!-- <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column> -->
  <el-table-column prop="uuidCode" :label="h_i18n('18f0d42ee6cabb8584f262eec975180e')" min-width="160"></el-table-column>
  <el-table-column prop="" :label="h_i18n('6c29d4ed37f89101dfb74f516187d05c')" min-width="200">
    <el-table-column prop="homegenousName" :label="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" min-width="100"></el-table-column>
    <el-table-column prop="homegenousSpecification" :label="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" min-width="100"></el-table-column>
  </el-table-column>
  <el-table-column prop="" :label="h_i18n('54652da1d2833157982155fceb688813')" min-width="800">
    <el-table-column prop="pb" label="Pb" min-width="80"></el-table-column>
    <el-table-column prop="cd" label="Cd" min-width="80"></el-table-column>
    <el-table-column prop="hg" label="Hg" min-width="80"></el-table-column>
    <el-table-column prop="cr" label="Cr(VI)" min-width="80"></el-table-column>
    <el-table-column prop="pbb" label="PBB" min-width="80"></el-table-column>
    <el-table-column prop="pbde" label="PBDE" min-width="80"></el-table-column>
    <el-table-column prop="dehp" label="DEHP" min-width="80"></el-table-column>
    <el-table-column prop="dbp" label="DBP" min-width="80"></el-table-column>
    <el-table-column prop="bbp" label="BBP" min-width="80"></el-table-column>
    <el-table-column prop="dibp" label="DIBP" min-width="80"></el-table-column>
  </el-table-column>
  <el-table-column prop="exemption" :label="h_i18n('5135b5a91526f3e49c5e8638f7852f58')" min-width="100"></el-table-column>
</el-table>
<el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="tableLoading || data.tableLoading1" @selection-change="listCheckBoxChange"
  @current-change="handleCurrentChange" highlight-current-row ref="singleTableRef" :row-class-name="tableRowClassName"
  border :data="postData.dataOfTable" size="small" height="100%" style="width: 100%;min-height:540px"
  v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" @click="clickTable" class="table_style">
  <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
  <!-- <el-table-column prop="uuidCode" label="识别码" min-width="160"></el-table-column> -->
  <el-table-column prop="" :label="h_i18n('6c29d4ed37f89101dfb74f516187d05c')" min-width="200">
    <el-table-column prop="homegenousName" :label="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" min-width="100">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.homegenousName"></el-input>
        <span v-else>{{ row.homegenousName }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="homegenousSpecification" :label="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" min-width="100">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.homegenousSpecification"></el-input>
        <span v-else>{{ row.homegenousSpecification }}</span>
      </template>
    </el-table-column>
  </el-table-column>
  <el-table-column prop="" :label="h_i18n('54652da1d2833157982155fceb688813')" min-width="800">
    <el-table-column prop="pb" label="Pb" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.pb"></el-input>
        <span v-else>{{ row.pb }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="cd" label="Cd" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.cd"></el-input>
        <span v-else>{{ row.cd }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="hg" label="Hg" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.hg"></el-input>
        <span v-else>{{ row.hg }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="cr" label="Cr(VI)" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.cr"></el-input>
        <span v-else>{{ row.cr }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="pbb" label="PBB" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.pbb"></el-input>
        <span v-else>{{ row.pbb }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="pbde" label="PBDE" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.pbde"></el-input>
        <span v-else>{{ row.pbde }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="dehp" label="DEHP" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.dehp"></el-input>
        <span v-else>{{ row.dehp }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="dbp" label="DBP" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.dbp"></el-input>
        <span v-else>{{ row.dbp }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="bbp" label="BBP" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.bbp"></el-input>
        <span v-else>{{ row.bbp }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="dibp" label="DIBP" min-width="80">
      <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.dibp"></el-input>
        <span v-else>{{ row.dibp }}</span>
      </template>
    </el-table-column>
  </el-table-column>
  <el-table-column prop="exemption" :label="h_i18n('5135b5a91526f3e49c5e8638f7852f58')" min-width="100">
    <template #default="{ row }">
        <el-input class="table_input_style" v-if="row.isEdit" v-model="row.exemption"></el-input>
        <span v-else>{{ row.exemption }}</span>
      </template>
  </el-table-column>
</el-table>
<br/>
<h-button-group align="center">
  <h-button type="primary" @click="submit" v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :loading="subLoading">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
          <h-button type="primary" @click="back">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
      </h-button-group>
<br/>
</h-inspection-page>
<h-upload-template :loading="loadingDown" @error="uploadError" :title="h_i18n('c3de08e8b73d392d68282f751aed8d8b')" :show="data.fileChoose" @close="closeUpload"
 :status="status" :dataList="dataList" @download="downFile" @fileChange="uploadTemplate"></h-upload-template>
<!-- <h-dialog :show="data.fileChoose" title="文件上传" footer @close="data.fileChoose = false"
      width="752px">
      <el-row>
        <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">
          请先下载模板，然后上传填写后的模板文件（请保证要导入的数据在第一个sheet页），
        </div>
        <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">
          最后点击导入按钮即可导入数据成功。
        </div>
      </el-row>
      <br>
      <span @click="downFile"
      style="color:#2681ff;font-size:14px;height:28px;line-height:28px;padding-left: 28px;cursor: pointer;">
        检测数据模板下载
      </span>
      <br>
      <br>
      
      <h-button type="primary" @click="importBtn">导入</h-button>
  </h-dialog> -->
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
const { proxy, ctx } = getCurrentInstance();
const route = useRoute();
const emit = defineEmit(
  ['submitBtn','backBtn']
)
const props = defineProps({
  kindType: {
    type: String,
    default: ''
  },
  getData: {
    type:Object,
    default: {}
  },
  tableLoading:{
    type:Boolean,
    default: false,
  },
  subLoading:{
    type:Boolean,
    default: false,
  }
})
const singleTableRef = ref('')
const data = reactive({
rowClick : false,
fileChoose:false,
})

const postData = reactive({
dataOfTable:[],
})
// 新增一行
const addBtn = () => {
postData.dataOfTable.push({isEdit:false})
proxy.postThisPageHeightMore()
}
// 删除
const removeBtn = () => {
if(data.rowListOfCheck?.length <= 0){
proxy.info(h_i18n('35e17c66aa6518681c5fa4db6bc09de8'))
return
}
let newTable = postData.dataOfTable.filter((item)=>{
return !data.rowListOfCheck.some(temp=>{
  return temp.index == item.index
})
})
postData.dataOfTable = newTable.map(item=>item)

data.rowListOfCheck = []
}
// 导入
const allImport = () => {
data.fileChoose = true
}
const submit = () => {
let tempTitle = {
  homegenousName:h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5'),
  homegenousSpecification:h_i18n('6ad1b6e0043132e6ae3f8a83487836bb'),
  pb:'Pb',
  cd:'Cd',
  hg:'Hg',
  cr:'Cr(VI)',
  pbb:'PBB',
  pbde:'PBDE',
  dehp:'DEHP',
  dbp:'DBP',
  bbp:'BBP',
  dibp:'DIBP',
  exemption:h_i18n('409bbfe8aa43b4b3d1caf7802844d6c2')
}
if(postData.dataOfTable?.length <= 0){
  proxy.info(h_i18n('c95dae6f456b20178338c215dae08332'))
  return
}
for(let i = 0 ; i < postData.dataOfTable.length; i++ ){
  let item = postData.dataOfTable[i]
  let flag = false
  for (const key in tempTitle) {
    if (!item[key] || !item[key].trim()) {
      flag = true
      proxy.warning(`${h_i18n('ac007746080a48f195815c62f8c1570c')}${i+1}${h_i18n('2d5aef4f2443b4694bd1dcc434636c6e')}${tempTitle[key]}${h_i18n('f7327186ec9f21ca0a90588360dab67a')}`)
      break
    }
  }
  if(flag){
    break
  }else if(i == postData.dataOfTable.length-1){
    data.nowCurrentRow ? data.nowCurrentRow.isEdit = false : ''
    emit("submitBtn",postData)
  }
}

}
// 导入模板
const uploadTemplate = (file) => {
    const formData = new FormData()

    formData.append("upfile", file)
    data.dataList = []
    data.status = ""
    proxy.startLoading(h_i18n('0b7da7ede9fae2ca88bfc8c9baabdfd1'))
    proxy.$http({
      method: "post",
      url: "/base/newrohs/rohsReportImport?userName=" + props.getData.trueName + "&uuid=" + data.uuid,
      data: formData,
    }).then((res) => {
      // if (res.data.code === "200") {
        // this.paginationQuery(this.pageNation.pageIndex)          
      // } else {
      // }
      data.status = "success"
      data.dataList = [h_i18n('b6d16a8173dd0d43f580bc6882dc5e9a')]
      proxy.closeLoading()
      closeUpload()
      updateInfo()
    }).catch(err=>{
      data.status = "error"
      data.dataList = res.data.data
      proxy.closeLoading()        
    })
  }
   //关闭导入模版
  const closeUpload = () => {
    data.fileChoose = false
    data.dataList = []
    data.status = ""
  }
const updateInfo = () => {
data.tableLoading1 = true
proxy.$http({
   url:'/base/newrohs/queryCheckDateList',
   method:'post',
    data:{
      fixConfig:true,
      uuid:data.uuid
    }
  }).then((res=>{
    postData.dataOfTable = res.data.data
  })).catch(err=>{

  }).finally(()=>{
    data.tableLoading1 = false
  })
}
const back = () => {
if(props.kindType == 'sqmModify' || props.kindType == 'sqmAdd'){
  proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('904909a3bc9af14ccc46ca821a29161c'),confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),callback:(type)=>{
    if(type == 'confirm'){
      submit()
    }else{
      emit("backBtn")
    }
  }})
}else{
  emit("backBtn")
}
}
/**
* 勾选操作
* @param {*} rowArr 勾选行
*/
const listCheckBoxChange = (rowArr) => {
data.rowListOfCheck = rowArr
console.log('勾选行',data.rowListOfCheck)
}

// 本地列表 index
const tableRowClassName = (row,rowIndex) => {
row.row.index = row.rowIndex
}

// 单选 选中行 事件 
const handleCurrentChange = (currentRow,oldCurrentRow) => {
// console.log(currentRow,oldCurrentRow)
data.nowCurrentRow = currentRow
currentRow && (currentRow.isEdit = true)
oldCurrentRow && (oldCurrentRow.isEdit = false)
}
// // table 点击事件
// const clickTable = () => {
//   data.rowClick = true
// }
// // 点击事件
// const clickPage = () => {
//   !data.rowClick && singleTableRef.value.setCurrentRow()
//   data.rowClick = false
// }


// 下载模板
const downFile = () => {
window.open("https://sqm.haier.net/readFile/basicInfo/检测数据.xlsx")
}
// 导入 按钮
const importBtn = () => {
// /rohsReportImport?uuid=3A7AE95B18BE71409F7B82D0C298A622&userName=%E5%BC%A0%E5%85%89%E7%9
console.log('importBtn')
}
onBeforeMount(()=>{
props.kindType == 'sqmAdd' && (data.title = h_i18n('caebab900a91b32b337ef82d770cf132'))
props.kindType == 'sqmModify' && (data.title = h_i18n('caebab900a91b32b337ef82d770cf132'))
props.kindType == 'sqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a')) && (data.dataOfTable = props.getData.dataOfTable)
props.kindType == 'hmqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a')) && (data.dataOfTable = props.getData.dataOfTable)
if(props.getData.dataOfTable.length > 0) {
  postData.dataOfTable = props.getData.dataOfTable
}
data.supplyCode = props.getData.supplyCode
data.supplyName = props.getData.supplyName
data.submitPerson = props.getData.trueName
data.uuid = route.query.uuid
})
onMounted(()=>{
})
</script>

<style lang="scss">
.ComponentDetectData_style{
.table_input_style{
  .el-input__inner{
    height:22px;
    line-height: 22px;
  }
}
.table_style{
  .el-table__body-wrapper{
    height:100% !important;
  }
}
.haier-title-lable{
  .haier-title-lable-left{
    span{
      display: none !important;
    }
  }
  .haier-title-lable-left::before{
    content: '';
    margin: 0px 10px;
    width:7px;
    height:7px;
    border-left: 2px solid #000;
    border-top: 2px solid #000;;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}
}
</style>